import { useState } from 'react';
import { Alert, Button, Card, Flex, Typography } from 'antd';
import type { CardPart } from '../chatReducer';
import { buttonState } from '../packView';

const CLOSED_TEXT: Record<string, string> = {
  start: 'Started: the crew is working below.',
  cancel: 'Cancelled.',
};

type StartCardProps = {
  card: CardPart;
  onAct: (action: 'start' | 'cancel') => void;
  busy: boolean;
};

/** The offer card (Plan 4a section 1): Start or Cancel. */
const StartCard = ({ card, onAct, busy }: StartCardProps) => {
  const [pending, setPending] = useState<'start' | 'cancel' | null>(null);
  const sending = card.cardState === 'sending';
  const start = buttonState(card, 'start');
  const cancel = buttonState(card, 'cancel');
  return (
    <Card size="small" title={card.title}>
      <Flex gap={8} align="center" wrap>
        {start !== 'hidden' && (
          <Button
            type="primary"
            disabled={
              start === 'disabled' || busy || (sending && pending !== 'start')
            }
            loading={sending && pending === 'start'}
            onClick={() => {
              setPending('start');
              onAct('start');
            }}
          >
            Start
          </Button>
        )}
        {cancel !== 'hidden' && (
          <Button
            disabled={cancel === 'disabled' || sending}
            loading={sending && pending === 'cancel'}
            onClick={() => {
              setPending('cancel');
              onAct('cancel');
            }}
          >
            Cancel
          </Button>
        )}
        {card.chosen && (
          <Typography.Text type="secondary">
            {CLOSED_TEXT[card.chosen] ?? ''}
          </Typography.Text>
        )}
      </Flex>
      {card.cardError && (
        <Alert
          style={{ marginTop: 8 }}
          type="error"
          showIcon
          message={card.cardError}
        />
      )}
    </Card>
  );
};

export default StartCard;
